import React, { useState} from 'react';
/* useState is used to set a value  */
//this  function send a user form with all information that is needed to prepare an answer
//css
import './RegisterCustomer.css';
import {useNavigate} from "react-router-dom";
import Button from "@mui/material/Button";
import BasicRating from "../materialComponents/BasicRating";

import Rating from '@mui/material/Rating';
import Box from '@mui/material/Box';
import StarIcon from '@mui/icons-material/Star';
import Typography from "@mui/material/Typography";
import {Container, Paper} from "@mui/material";


/*
SmartLuggage Application
27.07.2024
Marek Augustyn

*/
export const UserWelcomeFormTables = ({setCustomerInfo: setInfo}) => {



    //variable USER
    const navigateUserWelcomeFormTables = useNavigate();
    const [firstnameForm, setFirstnameForm] = useState('');
    const [lastnameForm, setLastnameForm] = useState('');
    const [emailForm, setEmailForm] = useState('');
    const [question1, setQuestion1] = useState('');


    // const [userPhoneNumber, setUserPhoneNumber] = useState('');
    // const [userDob, setUserDob] = useState('');
    // const [userAddress, setUserAddress] = useState('');

    // const [customerPasswordAgain, setCustomerPasswordAgain] = useState('');
    const [isError, setIsError] = useState('');
    const [isErrorFetchMethod, setIsErrorFetchMethod] = useState(null);
    const [formError, setFormError] = useState(null);
    const [formErrorEmpty, setFormErrorEmpty] = useState("");


    const [roles] = useState("ROLE_USER");
    const [active] = useState(true);


    const verifyAllFields = (event) => {
        if (!formError) {
            window.alert("Thank You for fill out the form.!")
            navigateUserWelcomeFormTables("/Login");
            return sendForm();

        }
        if (formError) {
            setFormErrorEmpty("CAN NOT BE EMPTY");
            event.preventDefault();
        }
    }


    //POST a data to the backend
    const sendForm = async () => {
        const result = await fetch("https://smartluggagebackendjwt-c266cf5456e9.herokuapp.com/api/v1/form", {
            method: "POST",
            body: JSON.stringify({
                firstnameForm,
                lastnameForm,
                emailForm,
                question1

            }),
            headers: {
                "Content-Type": "application/json",
            }
        }).catch((err) => {
            setIsErrorFetchMethod(err.message)
            console.log(err.response);
        })
        const body = await result.json().catch(err => console.log(err.response));
        setInfo(body).catch(err => console.log(err.response));
    }


    //USER validation
    // const validatePasswordJWT = (event) => {
    //     const pass = event.target.value;
    //     setCustomerPasswordAgain(pass);
    //     if (password !== pass) {
    //         if (password === " ") {
    //             setPasswordErrorEmpty("Can NOT be empty!");
    //         } else {
    //             setIsError("Passwords do NOT match!");
    //         }
    //     } else {
    //         setIsError("Password OK");
    //         setPasswordError(false);
    //         setPasswordErrorEmpty(" ")
    //     }
    // }


    const validateEmail = (event) => {
        const em = event.target.value;
        setEmailForm(em);
    }



    // Implementing rating

    const [value, setValue] = React.useState(2);


    return (
        <>



        <Container>




            <Box  sx={{

                display:"flex",
                alignItems:"center",
                '& > legend': { mt: 3 },

            }}>
                <Typography component="legend">Controlled</Typography>
                <Rating
                    name="controlled"
                    // size="large"
                    // value={value}
                    // onChange={(event, newValue) => {
                    //     setValue(newValue);
                    // }}
                    controlled
                />

                <Rating name="read-only" value={value} readOnly />

            </Box>

        </Container>


        // USER
        <div id="itemsInRegisterCustomer" className="row">

            <form className="col s12" onSubmit={(event) => verifyAllFields(event)}>



                <div className="row">
                    <div className="input-field col s10">
                        {isErrorFetchMethod && <div>{isErrorFetchMethod}</div>}
                        <div>{isErrorFetchMethod}</div>
                        <i className="material-icons prefix">account_circle</i>
                        <input placeholder="" value={firstnameForm} type="text"
                               onChange={(event => setFirstnameForm(event.target.value))} className="validate"/>
                        <label htmlFor="name">First Name JWT</label>
                    </div>
                </div>

                <div className="row">
                    <div className="input-field col s10">
                        <i className="material-icons prefix">account_circle</i>
                        <input placeholder="" value={lastnameForm} type="text"
                               onChange={(event => setLastnameForm(event.target.value))} className="validate"/>
                        <label htmlFor="surname">Surname</label>
                    </div>
                </div>

                <div className="row">
                    <div className="input-field col s10">
                        <i className="material-icons prefix">email</i>
                        <input placeholder="" value={emailForm} type="email" onChange={(event => validateEmail(event))}
                               className="validate"/>
                        <label htmlFor="email">Email</label>
                    </div>
                </div>

                <div className="row">
                    <div className="input-field col s10">
                        {isErrorFetchMethod && <div>{isErrorFetchMethod}</div>}
                        <div>{isErrorFetchMethod}</div>
                        <i className="material-icons prefix">question</i>
                        <input placeholder="" value={firstnameForm} type="text"
                               onChange={(event => setFirstnameForm(event.target.value))} className="validate"/>
                        <label htmlFor="name">First Name JWT</label>
                    </div>
                </div>
                {/*<div className="row">*/}
                {/*    <div className="input-field col s10">*/}
                {/*        <i className="material-icons prefix">phone</i>*/}
                {/*        <input placeholder="" value={userPhoneNumber} type="tel"*/}
                {/*               onChange={(event => setUserPhoneNumber(event.target.value))}*/}
                {/*               className="validate"/>*/}
                {/*        <label htmlFor="phoneNumber">Phone Number</label>*/}
                {/*    </div>*/}
                {/*</div>*/}

                {/*<div className="row">*/}
                {/*    <div className="input-field col s10">*/}
                {/*        <i className="material-icons prefix">cake</i>*/}
                {/*        <input value={userDob} type="date" onChange={(event => setUserDob(event.target.value))}*/}
                {/*               className="validate"/>*/}
                {/*        <label htmlFor="dob">Day of Birth</label>*/}
                {/*    </div>*/}
                {/*</div>*/}

                <div className="row">
                    <div className="input-field col s10">
                        <i className="material-icons prefix">home</i>
                        <input placeholder="" value={question1} type="text"
                               onChange={(event => setQuestion1(event.target.value))} className="validate"/>
                        <label htmlFor="surname">Tell me your current weight.</label>
                    </div>
                </div>

                {/*<div className="row">*/}
                {/*    <div className="input-field col s10">*/}
                {/*        <i className="material-icons prefix">password</i>*/}
                {/*        <input placeholder="" value={password} type="password"*/}
                {/*               onChange={(event => setPassword(event.target.value))}*/}
                {/*               className="validate"/>*/}
                {/*        <label htmlFor="customerPassword">Password</label>*/}
                {/*    </div>*/}
                {/*</div>*/}

                {/*<div className="row">*/}
                {/*    <div className="input-field col s10">*/}
                {/*        <i className="material-icons prefix">password</i>*/}
                {/*        <input placeholder="" value={customerPasswordAgain} type="password"*/}
                {/*               onChange={(event => validatePasswordJWT(event))}*/}
                {/*               className="validate"/>*/}
                {/*        <label htmlFor="customerPasswordAgain">Repeat the Password</label>*/}
                {/*        <div>{isError}</div>*/}
                {/*        <div>{passwordErrorEmpty}</div>*/}
                {/*        <div>{passwordError}</div>*/}
                {/*    </div>*/}
                {/*</div>*/}

                <div className="row">
                    <button
                        disabled={emailForm.length === 0 || question1.length === 0 || firstnameForm.length === 0}
                        id="buttonRegister"
                        className="waves-effect waves-light btn #795548 brown"
                        type="submit"
                        name="action">
                        Send
                    </button>
                </div>
                <div className="row">
                <Button variant="contained">Hello world</Button>
                <Button variant="text">Text</Button>
                <Button variant="contained">Contained</Button>
                <Button variant="outlined">Outlined</Button>
                </div>



            </form>

        </div>
        </>
    );
}

export default UserWelcomeFormTables;


